export default {
  pagination: {
    page: 1,
    rowsPerPage: 30,
  },
};



// WEBPACK FOOTER //
// ./src/store/notifications/state.js